export const endlessOfferAssets = {
	main: {
		backgroundPalmTreesMobile: "/spec_endless_offer/bg-palm-trees-mobile.png",
		backgroundPalmTrees: "/spec_endless_offer/bg-palm-trees.png",
		ropeSix: "/spec_endless_offer/rope-six.png",
		rope: "/spec_endless_offer/rope.png"
	},
	crab: {
		bubble: "/spec_endless_offer/crab-bubble-alt.png",
		character: "/spec_endless_offer/crab.gif"
	},
	node: {
		padlock: "/spec_endless_offer/padlock.png"
	},
	popup: {
		backgroundPalmTrees: "/spec_endless_offer/popup/bg-palm-trees.png",
		background: "/spec_endless_offer/popup/bg.png",
		title: "/spec_endless_offer/popup/title.png"
	}
} as const;
